export default (() => {
  try {
    const contextRequire = require.context(
      '.',
      true,
      /.*\.(mp4|ogg|webm)?$/,
    );
    contextRequire.keys().forEach(contextRequire);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
})();
